var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-page"},[_c('img',{attrs:{"src":require('@/assets/images/mobile-page.jpg'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }